// ===========================================================
// ERP INVENTORY MODULE
// ===========================================================

// Render Inventory UI
function renderInventoryUI(){
  const target = document.getElementById('inventory-target');
  if(!target) return;
  
  window.toggleLoader(true);
  
  const NO_IMAGE_LOCAL = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' style='background:%23e2e8f0'%3E%3Ctext x='50%25' y='50%25' dy='.3em' text-anchor='middle' font-family='sans-serif' font-size='10' fill='%2364748b'%3ENo Img%3C/text%3E%3C/svg%3E";

  const all = UI_DATA.inventory || [];
  const start = (CURRENT_PAGE.inventory - 1) * PAGE_SIZE;
  const pageItems = all.slice(start, start + PAGE_SIZE);
  
  if(!all.length){
    target.innerHTML = `
      <div class="empty-state-container">
        <div style="font-size:50px;margin-bottom:15px;opacity:.6">📦</div>
        <h3 style="margin:0;color:#1e293b">No Products Found</h3>
        <button onclick="resetInventoryFilters()" class="btn-export">Reset Filters</button>
      </div>`;
    window.toggleLoader(false);
    return;
  }

  const html = pageItems.map(p => `
    <div class="product-group-card" id="card-${p.id}">
      <div class="card-header" onclick="toggleProductTree('${p.id}')">
        <div class="product-info">
          <img src="${p.image?.src || NO_IMAGE_LOCAL}" class="product-thumb" onerror="this.onerror=null;this.src='${NO_IMAGE_LOCAL}'">
          <div>
            <h3 class="product-title">${p.title}</h3>
            <small class="product-meta">${p.variants.length} Variants | ${p.vendor}</small>
          </div>
        </div>
        <div id="icon-${p.id}" class="toggle-icon">+</div>
      </div>
      <div id="tree-${p.id}" class="card-content" style="display:none">
        <table class="enterprise-table">
          <thead>
            <tr><th>Variant</th><th>SKU</th><th>Price (${SHOP_CURRENCY})</th><th>Stock</th><th class="text-right">Action</th></tr>
          </thead>
          <tbody>
            ${p.variants.map(v => `
              <tr>
                <td class="font-medium">${v.title}</td>
                <td class="text-muted">${v.sku || 'N/A'}</td>
                <td class="price-text">${formatPrice(v.price)}</td>             
                <td class="stock-count" style="color:${v.inventory_quantity <= 0 ? '#ef4444' : (v.inventory_quantity <= 5 ? '#f59e0b' : 'inherit')}; font-weight:bold">
                  ${v.inventory_quantity}
                </td>
                <td class="text-right">
                  <div class="update-actions">
                    <input type="number" id="in-${v.id}" class="qty-input" placeholder="0">
                    <button onclick="syncStock('${v.id}','${v.inventory_item_id}', event)" class="btn-set">Set</button>
                  </div>
                </td>
              </tr>`).join('')}
          </tbody>
        </table>
      </div>
    </div>`).join('');

  target.innerHTML = `<div class="inventory-container">${html}</div><div id="inventory-pagination-holder"></div>`;
  renderPaginationUI('inventory', all.length, CURRENT_PAGE.inventory);
  window.toggleLoader(false);
}

// Toggle Product Tree
window.toggleProductTree = id => {
  const content = document.getElementById(`tree-${id}`);
  const icon = document.getElementById(`icon-${id}`);
  const card = document.getElementById(`card-${id}`);
  const open = content.style.display !== 'none';
  content.style.display = open ? 'none' : 'block';
  icon.innerText = open ? '+' : '−';
  card.style.borderColor = open ? '#e5e7eb' : '#10b981';
};

// Sync Stock
window.syncStock = async (vId, itemId, event) => { 
  const input = document.getElementById(`in-${vId}`);
  const newVal = parseInt(input.value);
  
  if (isNaN(newVal)) return alert('Please enter a valid number');
  
  const btn = event.target; 
  const origText = btn.innerText;
  btn.innerText = 'Saving...';
  btn.disabled = true;

  try {
    const res = await queryShopify('/inventory_levels/set.json', 'POST', {
      location_id: MASTER_DB.location,
      inventory_item_id: itemId,
      available: newVal
    });

    if (res && res.inventory_level) {
      MASTER_DB.products.forEach(p => {
        const variant = p.variants.find(v => v.id == vId);
        if (variant) variant.inventory_quantity = newVal;
      });

      UI_DATA.inventory = [...MASTER_DB.products];
      renderInventoryUI();
      updateStats();
      alert("✅ Stock Updated!");
    } else {
      throw new Error(res.error || 'Shopify update failed');
    }
  } catch (err) {
    console.error("Sync Error:", err);
    alert('❌ Update failed: ' + err.message);
  } finally {
    btn.innerText = origText;
    btn.disabled = false;
  }
};

// Filter Inventory
window.filterInventory = () => {
  const q = document.getElementById('inv-search')?.value.trim().toLowerCase() || '';
  const collId = document.getElementById('inv-coll')?.value || '';
  const vendor = document.getElementById('inv-vendor')?.value || '';
  const stockLimit = document.getElementById('inv-status')?.value || 'all';
  
  let mappedIds = collId ? MASTER_DB.mapping.filter(m => m.collection_id == collId).map(m => m.product_id) : null;
  
  UI_DATA.inventory = MASTER_DB.products.filter(p => {
    const totalStock = p.variants.reduce((a, v) => a + (v.inventory_quantity || 0), 0);
    const matchQ = p.title.toLowerCase().includes(q) || p.variants.some(v => v.sku?.toLowerCase().includes(q));
    const matchC = !mappedIds || mappedIds.includes(p.id);
    const matchV = !vendor || p.vendor === vendor;
    
    let matchStock = true;
    if(stockLimit === 'low') matchStock = (totalStock <= 5 && totalStock > 0);
    else if(stockLimit === 'out') matchStock = (totalStock <= 0);
    else if(stockLimit === 'in') matchStock = (totalStock > 0);
    
    return matchQ && matchC && matchV && matchStock;
  });
  
  CURRENT_PAGE.inventory = 1;
  renderInventoryUI();
};

// Reset Filters
window.resetInventoryFilters = () => {
  ['inv-search', 'inv-coll', 'inv-vendor', 'inv-status'].forEach(id => {
    const el = document.getElementById(id);
    if(el) el.tagName === 'SELECT' ? el.selectedIndex = 0 : el.value = '';
  });
  filterInventory();
};

// Setup Filter Dropdowns
function setupFilterDropdowns(){
  const coll = document.getElementById('inv-coll');
  const vend = document.getElementById('inv-vendor');

  if(coll && MASTER_DB.collections) {
    coll.innerHTML = '<option value="">All Collections</option>' +
      MASTER_DB.collections.map(c => `<option value="${c.id}">${c.title}</option>`).join('');
  }

  if(vend && MASTER_DB.products){
    const unique = [...new Set(MASTER_DB.products.map(p => p.vendor))].filter(v => v).sort();
    vend.innerHTML = '<option value="">All Vendors</option>' + 
      unique.map(v => `<option value="${v}">${v}</option>`).join('');
  }
}

// ===========================================================
// API FETCH FUNCTIONS (Added these missing functions)
// ===========================================================

async function fetchProducts() {
  // If data already exists in MASTER_DB, return it
  if(MASTER_DB.products && MASTER_DB.products.length > 0) {
    return MASTER_DB.products;
  }
  // Otherwise fetch from API
  const res = await queryShopify('/products.json?limit=250', 'GET');
  return res.products || [];
}

async function fetchCollections() {
  if(MASTER_DB.collections && MASTER_DB.collections.length > 0) {
    return MASTER_DB.collections;
  }
  const res = await queryShopify('/custom_collections.json?limit=250', 'GET');
  return res.custom_collections || [];
}

async function fetchMapping() {
  if(MASTER_DB.mapping && MASTER_DB.mapping.length > 0) {
    return MASTER_DB.mapping;
  }
  // Collects array - product to collection mapping
  const res = await queryShopify('/collects.json?limit=250', 'GET');
  return res.collects || [];
}

// ===========================================================
// INITIALIZATION
// ===========================================================

async function loadMasterData() {
  try {
    const [products, collections, mapping] = await Promise.all([
      fetchProducts(),
      fetchCollections(),
      fetchMapping()
    ]);
    
    MASTER_DB.products = products;
    MASTER_DB.collections = collections;
    MASTER_DB.mapping = mapping;
    
    UI_DATA.inventory = [...MASTER_DB.products];
  } catch(err) {
    console.error("Error loading master data:", err);
    throw err;
  }
}

async function initializeInventory() {
  try {
    window.toggleLoader(true);
    
    // Only fetch if data not already loaded
    if(!MASTER_DB.products || MASTER_DB.products.length === 0) {
      await loadMasterData();
    }
    
    // Setup dropdowns after data loads
    setupFilterDropdowns();
    
    // Then render
    renderInventoryUI();
    
  } catch(err) {
    console.error("Failed to initialize inventory:", err);
  } finally {
    window.toggleLoader(false);
  }
}

// Call this when page loads
document.addEventListener('DOMContentLoaded', () => {
  initializeInventory();
});